<main itemscope itemtype="https://schema.org/WebPage">
  
  <script type="application/ld+json" [innerHTML]="schemaJsonLd"></script>

  <section class="hero-section text-white text-center py-5">
    <div class="container py-lg-6">
      
      <p class="pre-header-text text-accent-gold" itemprop="keywords">PERSONALIZACIÓN EXCLUSIVA | ENVÍO GRATIS | UNIFORMES BORDADOS</p>
      
      <h1 class="main-seo-h1" itemprop="headline">
        Playeras Bordadas para Hombre y Mujer | Durabilidad 5X Garantizada en México
      </h1>
      
      <p class="lead pt-3 mx-auto" style="max-width: 900px;" itemprop="description">
        Diseños exclusivos con **Bordado de Logotipo, Nombre y Parches**. Olvídate de la serigrafía o sublimación, invierte en **Uniformes Bordados** de calidad que perdura. ¡**Envío GRATIS** en tu primer pedido mayorista a **todo México**! **Promoción por tiempo limitado.**
      </p>
      
      <div class="mt-5 action-buttons">
        <!--button class="btn btn-lg btn-accent-gold me-3" (click)="toggleModal()">
          <i class="fas fa-magic me-2"></i> Quiero mi Promoción + Envío GRATIS
        </button-->
         <a href="https://wa.me/5218110760979?text=Quiero%20mi%20Promoci%C3%B3n%20%2B%20Env%C3%ADo%20GRATIS" 
         class="btn btn-lg btn-accent-gold me-3" 
         target="_blank" 
         rel="noopener noreferrer">
        <i class="fab fa-whatsapp me-2"></i> Quiero mi Promoción + Envío GRATIS
      </a>
        <a routerLink="/product" class="btn btn-lg btn-outline-light">
          <i class="fas fa-tshirt me-2"></i> Ver Cortes Hombre y Mujer
        </a>
      </div>
    </div>
  </section>

  <section class="bg-promo-gold text-primary-dark py-4 promotion-bar">
    <div class="container d-flex flex-column flex-md-row justify-content-around align-items-center">
        <div class="promo-item mb-2 mb-md-0">
            <i class="fas fa-truck-fast fa-2x me-2"></i>
            <span class="font-weight-bold">¡Envío **GRATIS** a Todo México! (Pedido Mayorista)</span>
        </div>
        <div class="promo-item mb-2 mb-md-0">
            <i class="fas fa-star fa-2x me-2"></i>
            <span class="font-weight-bold">**Muestra de Bordado Digital** SIN COSTO.</span>
        </div>
        <div class="promo-item">
            <i class="fas fa-clock fa-2x me-2"></i>
            <span class="font-weight-bold">Entrega Garantizada: **5-10 Días Hábiles**.</span>
        </div>
    </div>
  </section>

  <section class="container py-5 gender-section">
      <h2 class="h3 text-center pb-5 seo-h2-gender">Cortes Perfectos: **Playeras Polo Bordadas** para Él y Ella</h2>
      <p class="text-center lead mx-auto mb-5" style="max-width: 800px;">
          Nuestros modelos de **Playeras para Hombre y Mujer** están diseñados para un ajuste profesional y cómodo. Usamos algodón y dry-fit en cortes específicos que realzan la figura, sin sacrificar la calidad necesaria para el bordado.
      </p>

      <div class="row gx-5">
          <div class="col-md-6 mb-4">
              <div class="gender-card border-left-gold p-4 h-100">
                  <h3 class="h4 card-title text-primary-dark"><i class="fas fa-male me-2"></i> Playeras **Polo** Bordadas para Hombre</h3>
                  <p class="text-muted">
                      Cortes rectos y atléticos, ideales para **uniformes empresariales masculinos**. Desde Polo de piqué hasta cuello redondo de algodón 100%. Garantizamos que el **bordado de tu logotipo** se verá nítido y profesional.
                  </p>
                  <a routerLink="/product" class="btn btn-sm btn-outline-dark mt-2">Ver Modelos de Hombre</a>
                  
                  <img src="https://storage.googleapis.com/download/storage/v1/b/camben-user.appspot.com/o/general%2Fplayera-hombre-03_20251203_011045.jpg?generation=1764724245909263&alt=media" 
                       alt="Playera de Hombre Bordada con Logotipo" class="img-fluid mt-3 rounded-lg shadow-sm">
              </div>
          </div>
          <div class="col-md-6 mb-4">
              <div class="gender-card border-left-gold p-4 h-100">
                  <h3 class="h4 card-title text-primary-dark"><i class="fas fa-female me-2"></i> Playeras Bordadas para Mujer</h3>
                  <p class="text-muted">
                      Diseños con siluetas semi-entalladas y cuellos femeninos (V o U). Ofrecemos comodidad y estilo para **uniformes de mujer**. La base perfecta para tu **bordado de nombre** o logo sutil.
                  </p>
                  <a routerLink="/product" class="btn btn-sm btn-outline-dark mt-2">Ver Modelos de Mujer</a>

                  <img src="https://storage.googleapis.com/download/storage/v1/b/camben-user.appspot.com/o/general%2Fplayera-mujer-portada_20251203_005730.jpg?generation=1764723451834603&alt=media" 
                       alt="Playera de Mujer Bordada con Corte Entallado" class="img-fluid mt-3 rounded-lg shadow-sm">
              </div>
          </div>
      </div>
  </section>

  <hr class="container divider-elegant">

  <section class="bg-light-gray py-5">
      <div class="container embroidery-focus-section">
          <h2 class="h3 text-center pb-5 seo-h2-embroidery">Tu Marca en Hilo: Bordado de Logotipo, Nombre y Parches</h2>

          <div class="row text-center">
              
              <div class="col-md-4 mb-4" itemscope itemtype="https://schema.org/Service">
                  <i class="fas fa-briefcase fa-3x text-accent-gold mb-3"></i>
                  <h3 class="h5" itemprop="name">Bordado de **Logotipo** (Identidad Empresarial)</h3>
                  <p class="text-muted" itemprop="description">Bordamos tu logotipo con precisión milimétrica en el pecho o manga. Utilizamos hilos de color de alta densidad que garantizan que el branding de tu **playera bordada** permanezca vibrante y profesional.</p>
              </div>

              <div class="col-md-4 mb-4" itemscope itemtype="https://schema.org/Service">
                  <i class="fas fa-id-badge fa-3x text-accent-gold mb-3"></i>
                  <h3 class="h5" itemprop="name">Bordado de **Nombre** (Staff y Uniformes)</h3>
                  <p class="text-muted" itemprop="description">Ideal para identificar a tu staff en **uniformes bordados para hombre y mujer**. Bordamos nombres individuales con **hilos de alta resistencia**, eliminando la necesidad de gafetes temporales.</p>
              </div>

              <div class="col-md-4 mb-4" itemscope itemtype="https://schema.org/Service">
                  <i class="fas fa-certificate fa-3x text-accent-gold mb-3"></i>
                  <h3 class="h5" itemprop="name">Bordado de **Parches** (Look Táctico o Moderno)</h3>
                  <p class="text-muted" itemprop="description">Fabricamos parches bordados o tejidos que se aplican a la prenda. Perfecto para uniformes de seguridad o un look de moda más robusto. Pídelos para tus **playeras Hangten**.</p>
              </div>
          </div>
      </div>
  </section>
  
  <section class="container py-5 final-cta-section">
    <div class="row align-items-center">
        <div class="col-lg-6 mb-4 mb-lg-0">
            <h2 class="h3 seo-h2-shipping">Servicio Superior en **Uniformes Bordados**: ¡Envío GRATIS y Asesoría 24/7!</h2>
            <p class="lead text-muted">
                Nuestra promesa de servicio supera a la competencia: no solo garantizamos la **máxima durabilidad** de tu **bordado**, sino también la máxima comodidad. Obtén **Envío GRATIS** y seguimiento personalizado por parte de tu asesor de ventas desde el diseño hasta la entrega final de tus **playeras personalizadas**.
            </p>
            <!--a routerLink="/contacto" class="btn btn-lg btn-primary-dark mt-3">
                <i class="fas fa-headset me-2"></i> Habla con un Asesor de Bordado
            </a-->

            <a href="https://wa.me/5218110760979?text=Quiero%20hablar%20con%20un%20asesor%20necesito%20playeras%20personalizadas" 
               class="btn btn-lg btn-primary-dark mt-3" 
               target="_blank" 
               rel="noopener noreferrer">
                <i class="fab fa-whatsapp me-2"></i> Habla con un Asesor de Bordado
            </a>
            
             <img src="https://storage.googleapis.com/download/storage/v1/b/camben-user.appspot.com/o/general%2Fplayera-hombre-04_20251203_011306.jpg?generation=1764724387617180&alt=media" 
                 alt="Playera de Hombre en uso con Bordado en pecho" class="img-fluid mt-4 d-none d-md-block rounded-lg shadow-lg" style="max-height: 250px; object-fit: cover;">
                 
        </div>
        <div class="col-lg-6 text-center">
            <div class="visual-placeholder shipping-promo-placeholder">
                <i class="fas fa-box-open fa-5x text-accent-gold"></i>
                <p class="mt-3 h4 text-primary-dark">Tu pedido mayorista, sin costo de envío.</p>
            </div>
            
             <img src="https://storage.googleapis.com/download/storage/v1/b/camben-user.appspot.com/o/general%2Fplayera-mujer-mejor_20251203_005846.jpg?generation=1764723527337508&alt=media" 
                 alt="Playera de Mujer con detalles de Bordado en la manga" class="img-fluid mt-4 rounded-lg shadow-lg" style="max-height: 350px; object-fit: cover;">
        </div>
    </div>
  </section>

  <section class="faq-section py-5 bg-light-gray">
    <div class="container">
      <h2 class="h3 text-center pb-4 seo-h2-faq">Preguntas Frecuentes sobre Playeras Bordadas (Hombre/Mujer)</h2>
      
      <div class="accordion-container-custom">
        
        <div class="faq-item" [class.open]="faqState[0].open">
          <div class="faq-question" (click)="toggleFaq(0)">
            <h3 class="h5 mb-0">¿El servicio de bordado incluye logos, nombres y parches?</h3>
            <span class="toggle-icon">{{ faqState[0].open ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer" [class.visible]="faqState[0].open">
            <p>Sí. Somos especialistas en bordado de alta precisión. Ofrecemos la personalización completa de tus **playeras (Hombre y Mujer)** incluyendo **logotipos empresariales**, nombres individuales (identificación de staff) y **parches bordados** con diseño personalizado. Todo con máxima durabilidad.</p>
          </div>
        </div>

        <div class="faq-item" [class.open]="faqState[1].open">
          <div class="faq-question" (click)="toggleFaq(1)">
            <h3 class="h5 mb-0">¿Cómo puedo obtener **Envío GRATIS** en mis Playeras Bordadas?</h3>
            <span class="toggle-icon">{{ faqState[1].open ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer" [class.visible]="faqState[1].open">
            <p>Ofrecemos **Envío GRATIS** en todos los pedidos mayoristas (a partir de 30 unidades) a cualquier parte de México. Queremos asegurarte el mejor precio total y la mayor conveniencia, superando la logística de nuestra competencia directa en **CDMX y Monterrey**.</p>
          </div>
        </div>
        
        <div class="faq-item" [class.open]="faqState[2].open">
          <div class="faq-question" (click)="toggleFaq(2)">
            <h3 class="h5 mb-0">¿Qué diferencia al Bordado CAMBEN de otros métodos de personalización?</h3>
            <span class="toggle-icon">{{ faqState[2].open ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer" [class.visible]="faqState[2].open">
            <p>Nos enfocamos en la durabilidad. El bordado es la técnica más resistente al lavado y al desgaste. Usamos hilos premium que no se decoloran, garantizando un acabado profesional y una vida útil 5 veces mayor que la serigrafía o la sublimación. Bordadas con la calidad de fábrica.</p>
          </div>
        </div>
        
        <div class="faq-item" [class.open]="faqState[3].open">
          <div class="faq-question" (click)="toggleFaq(3)">
            <h3 class="h5 mb-0">¿Tienen promociones especiales para pedidos grandes o clientes recurrentes?</h3>
            <span class="toggle-icon">{{ faqState[3].open ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer" [class.visible]="faqState[3].open">
            <p>Sí. Además del **Envío GRATIS**, ofrecemos descuentos escalonados por volumen y un precio preferencial en el ponchado (digitalización del logo) para clientes recurrentes. ¡Pregunta por nuestras **promociones vigentes**!</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <div class="modal-overlay" *ngIf="isModalOpen" (click)="toggleModal()">
    <div class="modal-content-custom" (click)="$event.stopPropagation()">
      <button class="close-btn" (click)="toggleModal()">&times;</button>
      <h3 class="text-center text-primary-dark">¡Aprovecha la Promoción! Cotiza tus Playeras Bordadas</h3>
      <p class="text-center text-muted">Obtén **Envío GRATIS** y asesoría personalizada para tu proyecto de **bordado de logotipo**.</p>
      </div>
  </div>
</main>